<footer>
  <div class="mb-1">v. {{ version }}</div>
  <div>&copy; {{ 'common.copyright' | translate }}</div>
</footer>
